export default __webpack_public_path__ + "static/emerging-industries-final-2db2f244ddbe6398f0924b370ca14e25.mp4";